'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var NavBrand = require('../components/NavBrand/NavBrand.js');
var NavToggle = require('../components/NavToggle/NavToggle.js');
var NavbarProfile = require('../MobileNavbar/NavbarProfile/NavbarProfile.js');
var DesktopMenu = require('./DesktopMenu/DesktopMenu.js');
var index = require('../../../../node_modules/classnames/index.js');
require('./DesktopNavbar.scss.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var DesktopNavbar = function (_a) {
    var isDesktop = _a.isDesktop;
    var _b = React.useState(false), isOffcanvasOpen = _b[0], setOffcanvasOpen = _b[1];
    return (React__default['default'].createElement(React__default['default'].Fragment, null,
        React__default['default'].createElement("nav", { className: "dn-root" },
            React__default['default'].createElement("div", { className: "container" },
                React__default['default'].createElement(NavToggle.NavToggle, { onClick: function () {
                        setOffcanvasOpen(function (prev) { return !prev; });
                    }, isOffcanvasOpen: false }),
                React__default['default'].createElement(NavBrand.NavBrand, null),
                React__default['default'].createElement(DesktopMenu.DesktopMenu, { isOffcanvasOpen: isOffcanvasOpen, isDesktop: isDesktop, onClick: function () {
                        setOffcanvasOpen(function (prev) { return !prev; });
                    } }),
                React__default['default'].createElement(NavbarProfile.NavbarProfile, null))),
        React__default['default'].createElement("div", { className: index['default']('offcanvas-backdrop', isOffcanvasOpen ? 'show' : ''), onClick: function () {
                setOffcanvasOpen(function (prev) { return !prev; });
            } })));
};

exports.DesktopNavbar = DesktopNavbar;
//# sourceMappingURL=DesktopNavbar.js.map
